export const SET_HOURS = 'SET_HOURS';
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';



// WEBPACK FOOTER //
// ./src/actions/constants.js